import PropTypes from 'prop-types';
import React from 'react';

import TextField from 'app/components/shared/TextField';

import { NUM_MAX_LINKS } from 'app/constants/admin/browse/home';
import { linksSectionShape, linksSectionValidationShape } from 'app/shapes/admin/browse/home';
import EditorLinks from './shared/EditorLinks';
import EditorHasAlternativeBackgroundToggle from './shared/EditorHasAlternativeBackgroundToggle';

import './SectionEditorLinks.scss';

const SectionEditorLinks = ({ onChange, section: linksSection, validation }) => {
  const { hasAlternativeBackground, heading, links, sectionId } = linksSection;
  const { errorByAttribute } = validation;

  const handleHasAlternativeBackgroundChange = newHasAlternativeBackground => {
    onChange({
      ...linksSection,
      hasAlternativeBackground: newHasAlternativeBackground
    });
  };

  const handleHeadingChange = newHeading => {
    onChange({
      ...linksSection,
      heading: newHeading
    });
  };

  const handleLinksChange = newLinks => {
    onChange({
      ...linksSection,
      links: newLinks
    });
  };

  const editorHasAlternativeBackgroundToggleKey = `${sectionId}_EditorHasAlternativeBackgroundToggle`;
  const editorLinksKey = `${sectionId}_EditorLinks`;
  const headingInputId = `${sectionId}_Heading`;

  return (
    <div className="cp-admin-browse-home-section-editor-links">
      <p className="rules">A maximum of {NUM_MAX_LINKS} links can be added</p>
      {!validation?.isValid && <p className="error">Section is invalid</p>}

      <div className="heading-field-wrapper">
        <TextField
          errorMessage={errorByAttribute.heading}
          id={headingInputId}
          label="Heading"
          onChange={handleHeadingChange}
          type="text"
          value={heading}
        />
      </div>

      <EditorHasAlternativeBackgroundToggle
        className="toggle-alt-background"
        key={editorHasAlternativeBackgroundToggleKey}
        onChange={handleHasAlternativeBackgroundChange}
        value={hasAlternativeBackground}
      />

      <EditorLinks
        key={editorLinksKey}
        links={links}
        onChange={handleLinksChange}
        validation={errorByAttribute.links}
      />
    </div>
  );
};

SectionEditorLinks.defaultProps = {
  validation: {
    isValid: true,
    errorByAttribute: {
      heading: '',
      links: {
        createLink: { isValid: true, errorByAttribute: { label: '', url: '' } }
      }
    }
  }
};

SectionEditorLinks.propTypes = {
  onChange: PropTypes.func.isRequired,
  section: linksSectionShape.isRequired,
  validation: linksSectionValidationShape
};

export default SectionEditorLinks;
